<template>
  <v-dialog
    v-model="is_open"
    :fullscreen="$vuetify.breakpoint.mobile"
    persistent
    scrollable
    width="500"
  >
    <v-card>
      <v-card-title class="font-weight-light">
        Update Batch Information
        <v-spacer></v-spacer>
        <v-btn
          color="red lighten-5 red--text"
          depressed
          rounded
          small
          @click="close_dialog"
          >Close
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="update_batch_form">
          <v-row dense>
            <v-col cols="12" class="mt-5">
              <v-text-field
                label="Batch Number"
                v-model="batch_number"
                :rules="$store.state.requiredRule"
                outlined
              ></v-text-field>
              <v-menu
                ref="menu"
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                v-if="is_expiry_item"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="expiry_date"
                    label="Expiry Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="$store.state.requiredRule"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="expiry_date"
                  @input="dateMenu = false"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          color="orange"
          dark
          depressed
          :loading="updating_batch"
          x-large
          rounded
          @click="update_batch"
          >Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["updateDialogOpen", "selected_batch"],
  data() {
    return {
      is_open: false,
      batch_number: "",
      batch_id: null,
      expiry_date: null,
      is_expiry_item: false,
      dateMenu: false,
      updating_batch: false,
    };
  },
  watch: {
    updateDialogOpen(val) {
      this.is_open = val;
    },
    selected_batch(val) {
      if (val) {
        this.batch_number = val.batch_number;
        this.batch_id = val.id;
        this.expiry_date = val.expiry_date;
        this.is_expiry_item = val.item.expires;
      }
    },
  },
  methods: {
    clear_form() {
      this.batch_number = "";
      this.expiry_date = null;
    },
    close_dialog() {
      this.$emit("update_closed");
      // this.clear_form();
    },
    update_batch() {
      if (this.$refs.update_batch_form.validate()) {
        this.updating_batch = true;
        const form_data = new FormData();
        form_data.append("batch_number", this.batch_number);
        if (this.is_expiry_item) {
          form_data.append("expiry_date", this.expiry_date);
        }
        axios
          .post(`/api/item-batches/${this.batch_id}`, form_data)
          .then((res) => {
            this.$emit("update_completed");
          })
          .catch((error) => {})
          .finally(() => {
            this.updating_batch = false;
          });
      }
    },
  },
};
</script>
